<script setup lang="ts">
import type { UISafeHtmlProps } from '../../types'
import sanitizeHtml from '../../utils/sanitizeHtml'
import { computed, h } from '#imports'

const props = withDefaults(defineProps<UISafeHtmlProps>(), { html: '', tag: 'div' })
const safeHtml = computed(() => sanitizeHtml(props.html))

// A render function, not `<component :is v-html>`: that trips vue/no-v-text-v-html-on-component, and the
// eslint-disable comment it needs would sit at the template root, which Vue keeps in dev and so renders a fragment.
// A component object, not a functional component: a functional one without declared props passes on only
// class/style/listeners, and would drop attributes such as data-test.
const render = { render: () => h(props.tag, { innerHTML: safeHtml.value }) }
</script>

<template>
    <render />
</template>
